import React, { useContext, useEffect, useRef } from 'react';
import { UeContainer, UeElement, UeReference } from '@oneaudi/falcon-tools';
import { NavigationBar, NavigationBarProps, Text } from '@oneaudi/unified-web-components';
import { Context } from '../../../../context/Context';
import { useTrackingManager } from '../../../../utils/useTrackingManager';
import { DesktopMenuContainer, DesktopMenuWrapper } from '../../SubPageNavigationStyles';
import { useI18n } from '../../../../i18n';
import { SUBMENUID, TRIGGERID } from '../../../../ContentType';
import { attachHorizontalNavigation } from '../../../../utils/a11y';

const DesktopMenu: React.FC = () => {
  const {
    stickymode,
    hasCta,
    content: { links },
    submenuDesktopRef,
    showSubmenu,
  } = useContext(Context);

  const { click } = useTrackingManager();

  const navRef = useRef<HTMLDivElement | null>(null);
  const ariaSubmenu = useI18n('ariaSubmenu');
  const ariaScrollLeft = useI18n('ariaScrollLeft');
  const ariaScrollRight = useI18n('ariaScrollRight');

  const navItems: NavigationBarProps['items'] = links.map(
    ({ text, href, ariaLabel, opensInNewTab, currentPage }, i) => ({
      label: (
        <Text tag="span" variant={{ type: 'copy', order: '1', style: 'normal' }}>
          <UeReference key={text} propertyPath={`links.${i}`} behavior="component">
            <UeElement type="text" label="Sub Pages">
              {text}
            </UeElement>
          </UeReference>
        </Text>
      ),
      href,
      target: opensInNewTab ? '_blank' : undefined,
      rel: opensInNewTab ? 'noopener noreferrer' : undefined,
      active: !!currentPage,
      icon: undefined,
      iconPosition: 'leading',
      onClick: () => {
        click('link', false, text, href, `${i + 1}`, '');
      },
      'aria-label': !currentPage && ariaLabel ? ariaLabel : undefined,
    }),
  );

  useEffect(() => {
    if (navRef.current) {
      attachHorizontalNavigation(navRef.current);
    }
  }, []);

  return (
    <DesktopMenuContainer isSticky={stickymode}>
      <DesktopMenuWrapper
        withCTA={hasCta}
        ref={submenuDesktopRef}
        className={showSubmenu && navItems.length > 0 ? 'show' : undefined}
        id={SUBMENUID.DESKTOP}
      >
        <UeContainer propertyPath="links" label="Sub Pages">
          <NavigationBar
            id="nav-bar__scrolling"
            scrollButtons={{
              left: { ariaLabel: ariaScrollLeft },
              right: { ariaLabel: ariaScrollRight },
            }}
            size="sm"
            items={navItems}
            className="subpage-navigation-bar"
            aria-label={ariaSubmenu}
            aria-labelledby={TRIGGERID.DESKTOP}
            ref={navRef}
          />
        </UeContainer>
      </DesktopMenuWrapper>
    </DesktopMenuContainer>
  );
};

export default DesktopMenu;
